module.exports = __webpack_public_path__ + "static/media/success.23b98d24.png";